<template>
  <div class="bee_invite_base_layout">

    <div class="mobile_layout">

      <mobileView :inviteUrl="inviteUrl" :inviteDispayUrl="inviteDispayUrl"
        :normalOnceRewardAmount="normalOnceRewardAmount" :superOnceReferralAmount="normalOnceRewardAmount"
        :friendsAmount="friendsAmount" :dividendYield="dividendYield" :xpCanClaimAmount="xpCanClaimAmount"
        :inviteCode="inviteCode" :listData="listData" @claim="claim" @share="showShareDialog">
      </mobileView>

    </div>


    <div class="pc_layout">
      <pcLayout :inviteUrl="inviteUrl" :inviteDispayUrl="inviteDispayUrl"
        :normalOnceRewardAmount="normalOnceRewardAmount" :superOnceReferralAmount="normalOnceRewardAmount"
        :friendsAmount="friendsAmount" :dividendYield="dividendYield" :xpCanClaimAmount="xpCanClaimAmount"
        :inviteCode="inviteCode" :listData="listData" @claim="claim">
      </pcLayout>
    </div>

    <shareDialog ref="shareDialog" @more="share" @copy="copyToPCClipboard" :xpNumber="dividendYield"
      :inviteUrl="inviteUrl">
    </shareDialog>



  </div>
</template>

<script>

import Toast from "../message.js";
import { AccountStore } from "../../util/Account.js";
import { InviteInfoStore } from "../../util/InviteInfo.js";
import UserListView from "../view/UserListView.vue"
import inviteBtn from "../view/inviteBtn.vue"
import pcLayout from "./pcView.vue"
import shareDialog from "./shareDialog.vue"
import mobileView from "./phoneHome.vue"

import { base_url } from '../../util/mock.js'


export default {
  name: 'HomeView',

  components: {
    UserListView,
    inviteBtn,
    pcLayout,
    shareDialog,
    mobileView
  },

  props: {
    title: String,
    msg: String,
  },

  data() {
    return {
      loginUrl: "",
      isUserLoginStatus: false,
      inviteData: '',
      inviteCode: "",
      xpNumber: 10,
      listData: [
        // {
        //   "userId": "testp000@qq.com",
        //   "name": "testp000",
        //   "avatar": "",
        //   "dividendXp": 2600.000000000018
        // },
        // {
        //   "userId": "kiko@nqmo.com",
        //   "name": "kiko",
        //   "avatar": "",
        //   "dividendXp": 2523.2000000000007
        // },
        // {
        //   "userId": "testp000@qq.com",
        //   "name": "testp000",
        //   "avatar": "",
        //   "dividendXp": 2600.000000000018
        // },
        // {
        //   "userId": "kiko@nqmo.com",
        //   "name": "kiko",
        //   "avatar": "",
        //   "dividendXp": 2523.2000000000007
        // },
        // {
        //   "userId": "testp000@qq.com",
        //   "name": "testp000",
        //   "avatar": "",
        //   "dividendXp": 2600.000000000018
        // },
        // {
        //   "userId": "kiko@nqmo.com",
        //   "name": "kiko",
        //   "avatar": "",
        //   "dividendXp": 2523.2000000000007
        // },
        // {
        //   "userId": "testp000@qq.com",
        //   "name": "testp000",
        //   "avatar": "",
        //   "dividendXp": 2600.000000000018
        // },
        // {
        //   "userId": "kiko@nqmo.com",
        //   "name": "kiko",
        //   "avatar": "",
        //   "dividendXp": 2523.2000000000007
        // },
        // {
        //   "userId": "testp000@qq.com",
        //   "name": "testp000",
        //   "avatar": "",
        //   "dividendXp": 2600.000000000018
        // },
        // {
        //   "userId": "kiko@nqmo.com",
        //   "name": "kiko",
        //   "avatar": "",
        //   "dividendXp": 2523.2000000000007
        // },
        // {
        //   "userId": "testp000@qq.com",
        //   "name": "testp000",
        //   "avatar": "",
        //   "dividendXp": 2600.000000000018
        // },
        // {
        //   "userId": "kiko@nqmo.com",
        //   "name": "kiko",
        //   "avatar": "",
        //   "dividendXp": 2523.2000000000007
        // }
      ],
      inviteUrl: '',
      inviteDispayUrl: "",
      isClaim: false,

      normalOnceRewardAmount: 0,
      superOnceReferralAmount: 0,
      friendsAmount: 0,
      dividendYield: 0,
      xpCanClaimAmount: 0,


    }
  },

  watch: {
  },

  methods: {

    doClose() {
      let view = document.getElementById("bee_nInvite");
      view.style.display = "none";
    },

    getQueryString(url) {
      let ItemArr = [];
      let ItemObj = {};
      url
        .substring(url.lastIndexOf("?") + 1, url.length)
        .split("&")
        .map((item) => {
          ItemArr.push(item.split("="));
        });
      ItemArr.map((item) => {
        ItemObj[item[0]] = item[1];
      });
      return ItemObj;
    },


    async getUserLoginInfo() {
      await AccountStore.fetchUserInfo();
      this.isUserLoginStatus = AccountStore.isUserLoginStatus;
      if (this.isUserLoginStatus) {
        await InviteInfoStore.fetchInviteInfo();

        // console.log(InviteInfoStore.iInviteInfo);
        this.inviteData = InviteInfoStore.iInviteInfo;
        this.inviteCode = this.inviteData.referralCode;
        this.inviteUrl = base_url() + "?bCode=" + this.inviteCode;
        this.inviteDispayUrl = "http://w" + "..." + "?bCode=" + this.inviteCode;
        this.xpNumber = this.inviteData.dividendYield * 100;
        this.xpCanClaimAmount = this.inviteData.xpCanClaimAmount;

        this.dividendYield = this.inviteData.dividendYield * 100;
        this.xpCanClaimAmount = this.inviteData.xpCanClaimAmount;
        this.normalOnceRewardAmount = this.inviteData.normalOnceRewardAmount;
        this.superOnceReferralAmount = this.inviteData.superOnceReferralAmount;
        this.friendsAmount = this.inviteData.friendsAmount;

        this.listData = InviteInfoStore.friends;

      } else {

      }

    },

    goInvite() {
      let url = base_url() + "?bCode=" + this.inviteCode;
      window.location.href = url;
    },

    async claim() {
      // if (this.xpCanClaimAmount == 0) {
      //   return;
      // }
      // this.isClaim = true;
      await this.getUserLoginInfo();
      // this.isClaim = false;
    },
    showShareDialog() {
      this.setFackbookTxt();
      this.$refs.shareDialog.showDialog();
      // this.share();
    },

    copyToPCClipboard() {
      console.log("copyToClipboard")
      let copyText = "Come to Bee.com to collect your " + this.dividendYield + "% XP rewards!" + "Stay ahead with the latest crypto trends and discover promising potential projects. Arm yourself with knowledge and insights in this bull run!" + " " + this.inviteUrl;

      navigator.clipboard.writeText(copyText).then(() => {
        Toast("Copy successful", "success")
      });

    },

    copyToClipboard(copyText) {

      navigator.clipboard.writeText(copyText).then(() => {
        Toast("Copy successful", "success")
      });

    },

    setFackbookTxt() {
      var meta = document.createElement('meta');
      meta.setAttribute('og:description', "Come to Bee.com to collect your " + this.dividendYield + "% XP rewards!" + "Stay ahead with the latest crypto trends and discover promising potential projects. Arm yourself with knowledge and insights in this bull run!");
      document.head.appendChild(meta);
    },

    share() {
      if (navigator.share) {
        navigator.share({
          title: "",
          text: "Come to Bee.com to collect your " + this.dividendYield + "% XP rewards! "+"Stay ahead with the latest crypto trends and discover promising potential projects. Arm yourself with knowledge and insights in this bull run!",
          url: this.inviteUrl
        }).then(() => {
          console.log('Successful share');
        }).catch(error => {
          console.log('Error sharing:', error);
        });
      } else {
        console.log('Web Share API is not supported.');
        this.showBeeShare();
      }
    },


    showBeeShare() {
      let shareContent = {
        share: this.inviteUrl,
        title: "Come to Bee.com to collect your " + this.dividendYield + "% XP rewards!",
        content: "Stay ahead with the latest crypto trends and discover promising potential projects. Arm yourself with knowledge and insights in this bull run!",
      };
      // console.log(shareTxt + '');
      try {
        if (window.flutter_inappwebview) {
          //
          window.flutter_inappwebview.callHandler('sharePic', JSON.stringify(shareContent));
        } else {
          window.flutter_inappwebview._callHandler('sharePic', JSON.stringify(shareContent));
        }
      } catch (e) {
        //TODO handle the exception


        navigator.clipboard.writeText(this.inviteUrl).then(() => {
          Toast("Copy successful", "success")
        });
      }
    }


  },

  mounted() {
    this.getUserLoginInfo();
  },


}

</script>

<style scoped>
.bee_invite_base_layout {
  position: fixed;
  z-index: 2001;
  flex-direction: column;
  display: flex;
  width: -webkit-fill-available;
  width: -moz-available;
  height: 100%;
  background-color: #fff;
}

.reward_content_radius {
  width: 76px;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 40px;
  flex-direction: column;
  background-color: #F29100;
  margin-left: -4px;
  border-radius: 8px;
  padding-top: 4px;
  padding-bottom: 4px;
  border: 1px solid #fff;
}

.reward_content {
  width: 68px;
  height: 63px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  background-size: cover;
  background-repeat: no-repeat;
  opacity: 0.6;
  /* animation: rotate 10s linear infinite; */
}

@keyframes rotate {
  0% {
    transform: rotateY(0);
  }

  100% {
    transform: rotateY(720deg);
  }
}

.line {
  width: 1px;
  height: 150px;
  background-color: #f2f2f2;
}

.bee_experience_logo {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  border-radius: 100%;
  margin-left: 2px;
}


.icon_back {
  width: 20px;
  height: 20px;
  background-image: url("../../assets/icon_dialog_close.png");
  background-size: cover;
  background-repeat: no-repeat;
  box-sizing: border-box;
  cursor: pointer;
}

.reward_xp_layout {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
}

.reward_text {
  font-size: 10px;
  color: #00c170;
  height: 16px;
  border-radius: 30px;
  background: #c6ffe7;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  padding-left: 18px;
  padding-right: 18px;
  margin-bottom: 2px;
  margin-top: 2px;
}

.mint_txt {
  color: #fff;
  font-size: 16px;
  width: 40px;
  text-align: center;
}



.top_layout {
  background-color: #FFEFDA;
}

.xp_login {
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  text-align: center;
  color: #fff;
}

.task_send {
  cursor: pointer;
  border-radius: 30px;
  background: #FFAE00;
  color: #FFF;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  /* 166.667% */
  letter-spacing: 0.12px;
  padding-top: 4px;
  padding-bottom: 4px;
  width: 80px;
}

.header_bar {
  display: flex;
  flex-direction: row;
  height: 56px;
  align-items: center;
  padding-left: 16px;
  padding-right: 16px;
}

.invite_info_layout {
  display: flex;
  flex-direction: row;
  margin-left: 16px;
  margin-right: 16px;
}

.invite_info {
  color: #000;
  font-family: "SF Pro Text";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
  flex: 1;
  width: 45%
}

.img_ipx {
  width: 90%;
  height: 190px;
  margin-right: 16px;
  background-image: url("../../assets/icon_top_i.png");
  background-size: cover;
  background-repeat: no-repeat;
  box-sizing: border-box;
}

.xp_num {
  color: #E44430;
  font-family: "SF Pro Text";
  font-size: 16px;
  font-style: normal;
  font-weight: 800;
  line-height: 24px;
}

.my_invite_xp_layout {
  border-radius: 8px;
  background: #F8F8F8;
  display: flex;
  justify-content: space-between;
  width: -webkit-fill-available;
  width: -moz-available;
  margin-left: 16px;
  margin-right: 16px;
  margin-top: 16px;
  padding: 12px;
  align-items: center;
}

.submit_get {
  color: #FFF;
  font-family: "PingFang SC";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  border-radius: 8px;
  background: linear-gradient(90deg, #FFBF6C 0%, #F68F1A 100%);
  height: 32px;
  padding-left: 10px;
  padding-right: 10px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.submit_get_un {
  font-family: "PingFang SC";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  border-radius: 8px;
  background: #f2f1ef;
  color: #d4d1c9;
  height: 32px;
  padding-left: 10px;
  padding-right: 10px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}


.submit_load {
  color: #FFF;
  font-family: "PingFang SC";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  border-radius: 8px;
  background: #FFE7B3;
  height: 32px;
  padding-left: 10px;
  padding-right: 10px;
  justify-content: center;
  align-items: center;
  width: 60px;
  display: flex;
}



.my_txt {
  color: #666;
  font-family: "SF Pro Text";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.xp_txt {
  color: #000;
  font-family: "SF Pro Text";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.xp_num_txt {
  color: #000;
  font-family: "SF Pro Text";
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.index_layout {
  width: 2px;
  height: 14px;
  background: #FFC04D;
  margin-right: 4px;
}

.index_title {
  color: #333;
  font-family: "PingFang SC";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.index_base_layout {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 16px;
  margin-top: 16px;
  margin-bottom: 8px;
}

.invite_layout {
  border-radius: 8px;
  background: #F8F8F8;
  display: flex;
  flex-direction: column;
  margin-left: 16px;
  margin-right: 16px;
}

.invite_left_txt {
  color: #666;
  font-family: "SF Pro Text";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.invite_item_layout {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  padding: 12px;
}

.invite_right_layout {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: right;
  flex: 1;
}

.invite_right_txt {
  color: #000;
  font-family: "SF Pro Text";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-align: right;
  width: 120px;
  white-space: nowrap;
  overflow: hidden;
}

.icon_copy {
  width: 20px;
  height: 20px;
  background-image: url("../../assets/icon_copy.png");
  background-size: cover;
  background-repeat: no-repeat;
  box-sizing: border-box;
  margin-left: 12px;
  cursor: pointer;
}

.line {
  display: flex;
  height: 1px;
  stroke-width: 1px;
  stroke: rgba(240, 238, 238, 0.93);
  background-color: rgba(240, 238, 238, 0.93);
  margin-left: 12px;
  margin-right: 12px;
  width: -webkit-fill-available;
  width: -moz-available;
}

.scroll_layout {
  background-color: #fff;
}

.loading_logo {
  width: 18px;
  height: 18px;
  background-image: url("https://www.bee.com/wp-content/uploads/2025/03/loading.gif");
  background-size: cover;
  background-repeat: no-repeat;
  /* animation: rotate 2s linear infinite; */
}

.pc_layout {
  display: flex;
  flex-direction: column;
  width: -webkit-fill-available;
  width: -moz-available;
  background: #fff;
  height: -webkit-fill-available;
  height: -moz-available;
}

.mobile_layout {
  display: none;
  flex-direction: column;
  width: -webkit-fill-available;
  width: -moz-available;
  height: 110%;
  background-color: #fff;
  background-image: url("../../assets/rf_bg.png");
  background-size: cover;
  background-repeat: no-repeat;
}

@media (max-width:767.98px) {
  .mobile_layout {
    display: flex;
    flex-direction: column;
    width: -webkit-fill-available;
    width: -moz-available;
    background-image: url("../../assets/rf_bg.png");
    background-size: cover;
    background-repeat: no-repeat;
  }

  .pc_layout {
    display: none;
    flex-direction: column;
    width: -webkit-fill-available;
    width: -moz-available;
  }
}
</style>
